export default "/images/MoiraBianchi.jpg?350696acfe1022e13ad9d4159c7ef198";